export default __webpack_public_path__ + "static/media/Screenshot_5.b17e5401.webp";